<template>
  <div class="filters" v-bind:class="{ 'filters--active': mobileOpen, 'filters--horizontal': settings.horizontalFilters }">
    <button class="filters__skip" @click.stop="goTo('#vue-search')">Skip To Search</button>
    <button class="filters__skip" @click.stop="goTo('#vue-results')">Skip To Results</button>
    <button
      class="filters__toggle"
      type="button"
      @click="mobileOpen = !mobileOpen"
    >
      {{ settings.filterText }}
    </button>
    <h6 class="filters__heading">{{ settings.filterText }}</h6>
    <div class="filters__inner" @click.self="mobileOpen = false">
      <div class="filters__content">
        <button
          class="filters__close"
          type="button"
          @click="mobileOpen = false"
        >
          Close
        </button>
        <div class="filters__form">
          <div class="filters__main">
            <div
              class="filters__group"
              v-bind:key="filterGroup.id"
							:id="'group-' + returnValidIdVal(filterGroup.id)"
              v-for="(filterGroup, i) in visibleFilters"
            >
              <div
                class="filters__title"
                tabindex="0"
                role="button"
                @keypress.enter.stop="toggleFilter($event, i)"
                @click="toggleFilter($event, i)"
                :data-active="filterState[i]"
              >
                <div class="filters__tooltip" v-if="false && ($root.devData || filterGroup.tooltip)">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" tabindex="0" :aria-label="`Tooltip: ${ $root.devData ? 'Information explaining this filter will show up here' : filterGroup.tooltip}`"><path opacity=".1" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" fill="#006177"/><path d="M12 17.5v0m0-3.6c0-3.3 3-2.5 3-5a3 3 0 0 0-3-2.4 3 3 0 0 0-2.9 2" stroke="#006177" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="#006177" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17.5v0Z" stroke="#006177" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg>

                  <span class="filters__tooltip-text">{{ $root.devData ? "Information explaining this filter will show up here" : filterGroup.tooltip }}</span>
                </div>

                <div class="filters__count" v-if="selectedCountInGroup(filterGroup) > 0">
                  {{ selectedCountInGroup(filterGroup) }}
                </div>
                
                {{ filterGroup.name }}
              </div>
              <Transition>
                <div
                  class="filters__options"
                  v-show="filterState[i]"
                  :data-active="filterState[i]"
                >
                  <div class="filters__options-inner">
                    <template v-for="filter in filterGroup.filters">
                      <div
                        class="filters__option"
                        v-bind:key="filter.id"
                        v-if="filter.count > 0"
                        @click.stop
                      >
                        <input
                          class="filters__input"
                          type="checkbox"
                          v-model="filter.selected"
                          @change="checkForSingleSelect(filter.id, filterGroup.id)"
                          :id="'filter-' + returnValidIdVal(filter.id)"
                        />
                        <label class="filters__label" :for="'filter-' + returnValidIdVal(filter.id)">{{
                          getFilterText(filter)
                        }}</label>
                      </div>
                    </template>
                  </div>
                </div>
              </Transition>
            </div>
          </div>
          <FilterKey v-if="settings.includedHTML.filterKey && $root.filterKeyLabel"/>
          <div class="filters__btns">
            <button class="btn filters__btn clear-btn" @click="clearFilters" v-if="$root.showReset && hasFilters.selected">
              {{ $root.resetText }}
            </button>
            <button class="btn filters__btn" @click="submitFilters" v-if="settings.showFilterButton" :disabled="!(hasFilters.selected || hasFilters.results)">
              {{ settings.filterButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionExpand from "./global/TransitionExpand";
import FilterKey from "./FilterKey";

const openFilter = {};

export default {
  props: {
    showContentType: {
      type: Boolean,
    },
    showCategories: {
      type: Boolean,
    },
    filterGroups: {
      type: Array,
    }
  },
  components: {
    appTransitionExpand: TransitionExpand,
    FilterKey,
  },
  data: function () {
    return {
      loaded: false,
      mobileOpen: false,
      filterState: [],
			singleSelectFilterIds: [],
			queryIds: null
    };
  },
  watch: {
    filters() {
      if (!this.loaded && this.$route.query.c && this.filters.length > 0) {
        var f = JSON.parse(JSON.stringify(this.filters));
        this.updateFiltersFromQuerystring(this.$route.query.c, f);

        this.$emit("submitFilters", f);
        this.loaded = true;
      }
    },
  },
  computed: {
    filters: function () {
      return this.$store.state.results.filters;
    },
    settings: function () {
      return this.$store.state.settings;
    },
    visibleFilters: function () {
      let tempFilters = this.$props.showContentType
        ? this.filters.filter((f) => f.visible == true)
        : this.filters.filter(
            (f) => f.visible == true && f.id != "search_contenttype"
          );
      return this.$props.showCategories
        ? tempFilters
        : tempFilters.filter((f) => f.id == "search_contenttype");
    },
    allowedFilters: function () {
      return this.$props.filterGroups;
    },
    hasFilters: function () {
      return {
        results: this.$store.state.searchQuery.filters.some((f) => f.filters.some((fn) => fn.selected)),
        selected: this.visibleFilters.some((f) => f.filters.some((fn) => fn.selected)),
      }
    },
  },
  methods: {
    goTo(id) {
      const dest = document.querySelector(id);
      const focusable = 'a, button, input, select, textarea, [tabindex]:not([tabindex*="-"])';

      if (dest.matches(focusable)) {
        dest.focus();
      }
      else {
        dest.querySelector(focusable).focus();
      }
    },
		returnValidIdVal(id) {
			return id.replace(/[^a-zA-Z0-9]/g, '');
		},
    toggleFilter(e, i) {
      e.stopPropagation();
      
      const filterState = [...this.filterState];

      if (i >= 0) {
        const newVal = !filterState[i];
        if (this.settings.horizontalFilters)
          filterState.fill(false);
        filterState[i] = newVal;
      }

      if(filterState[i]) {
        openFilter.index = i;
        openFilter.parent = e.target.parentElement;
        if (!openFilter.interval)
          openFilter.interval = requestAnimationFrame(checkFilterOffscreen);
      }
      else {
        openFilter.index = null;
        openFilter.parent = null;
        cancelAnimationFrame(openFilter.interval);
        openFilter.interval = null;
      }

      this.filterState = filterState;
    },
    submitFilters: function () {
      this.$emit("submitFilters", this.filters);
    },
		checkForSingleSelect: function(itemId, groupId) {
			let isSingleSelect = this.singleSelectFilterIds.includes(groupId);
			let checkEl = this.$el.querySelector(`#filter-${this.returnValidIdVal(itemId)}`);
			if (!checkEl) return;
			let isChecked = checkEl.checked;
			let filterGroupElement = this.$el.querySelector(`#group-${this.returnValidIdVal(groupId)}`);
			let filterElements = [...filterGroupElement.querySelectorAll(".filters__input")];
			if (!!isSingleSelect && isChecked) {
				filterElements.forEach((filterElement) => {
					if (filterElement.id != "filter-" + this.returnValidIdVal(itemId)) {
						filterElement.checked = false;
						filterElement.disabled = true;
					}
				});
			} else if (!isChecked) {
				filterElements.forEach((filterElement) => {
					filterElement.disabled = false;
				});
			}
			if (!this.settings.showFilterButton) this.submitFilters();
		},
    updateFiltersFromQuerystring(query, filters) {
      this.queryIds = query.split(",");

      this.queryIds.forEach(function (theID) {
        filters.forEach(function (parent) {
          var match = parent.filters.find((c) => c.id === theID);

          if (match) {
            match.selected = true;
          }
        });
      });
    },
    getFilterText: function (filter) {
      return filter.value;
    },
    clearFilters: function () {
      this.filters.forEach((group) => {
        group.filters.forEach((filter) => {
          filter.selected = false;
        });
      });
      this.filterState = this.filterState.fill(false);
      this.submitFilters();
    },
    selectedCountInGroup: function (group) {
      return group.filters.reduce((acc, filter) => filter.selected ? acc + 1 : acc, 0);
    },
    checkCloseDropdown: function(e) {
      if (e.type === 'click' && e.srcElement.closest('.filters__group')) return;
      else if (e.type === 'keydown' && e.key !== 'Escape') return;
      this.filterState = [...this.filterState.fill(false)];
    },
  },
  created() {
		this.singleSelectFilterIds = this.$root.singleSelectFilters.split(",");
		var query = this.$route.query.c;
		this.queryIds = query ? query.split(",") : [];
		var changed = false;
		this.filters.forEach((group) => {
			group.filters.forEach((filter) => {
				if (this.queryIds.includes(filter.id) && !filter.selected) {
					filter.selected = true;
					changed = true;
				}
			});
		});
		if (changed) {
			this.submitFilters();
		}
  },
  mounted() {
    let filterState = [];
    this.filters.forEach((filterGroup, i) => {
      filterState.push(i === 0 && !this.$store.state.settings.horizontalFilters);
    });
    this.filterState = filterState;

    document.addEventListener("click", this.checkCloseDropdown);
    window.addEventListener("keydown", this.checkCloseDropdown);

		
		this.filters.forEach((group) => {
			group.filters.forEach((filter) => {
				if (this.queryIds.includes(filter.id)) {
					this.checkForSingleSelect(filter.id, group.id);
				}
			});
		});
  },
  beforeDestroy: function () {
    this.filterState = [];

    document.removeEventListener("click", this.checkCloseDropdown);
    document.removeEventListener("keydown", this.checkCloseDropdown);
  },
};

function checkFilterOffscreen() {
  if (!(openFilter.index + 1) || !openFilter.parent) return;

  const options = openFilter.parent.querySelector(".filters__options");
  if (!options) return;

  const rect = options.getBoundingClientRect();
  if (rect.right > window.innerWidth - 30)
    options.classList.add("align-right");

  requestAnimationFrame(checkFilterOffscreen);
}
</script>